import React from "react";
import Layout from "../Layout";
import { BiUserPlus, BiLogOut } from "react-icons/bi";
import { RiLockPasswordLine } from "react-icons/ri";
import PersonalInfo from "../components/UsedComp/PersonalInfo";
import ChangePassword from "../components/UsedComp/ChangePassword";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/features/userSlice";
import { useNavigate } from "react-router-dom";
import OperatorInfo from "../components/UsedComp/OperatorInfo";

function Settings() {
  const [activeTab, setActiveTab] = React.useState(1);
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tabs = [
    {
      id: 1,
      name: "Personal Information",
      icon: BiUserPlus,
    },
    {
      id: 2,
      name: "Change Password",
      icon: RiLockPasswordLine,
    },
    {
      id: 3,
      name: "Log out",
      icon: BiLogOut,
    },
  ];

  const tabPanel = () => {
    switch (activeTab) {
      case 1:
        return <OperatorInfo titles={false} />;
      case 2:
        return <ChangePassword />;
      case 3:
        dispatch(setUser(null)); // Clear user data
        navigate("/intro"); // Redirect to login
        return null; //
      default:
        return;
    }
  };

  return (
    <Layout>
      <h1 className="text-xl font-semibold text-yellowlight">Settings</h1>
      <div className=" grid grid-cols-12 gap-6 my-8 items-start">
        <div
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-delay="100"
          data-aos-offset="200"
          className="col-span-12 flex-colo gap-6 lg:col-span-4 bg-white rounded-xl border-[1px] border-border p-6 lg:sticky top-28"
          style={{
            backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url(${user?.coverPhoto})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <img
            src={user?.photo}
            alt="setting"
            className="w-40 h-40 rounded-full object-cover border border-dashed border-subMain"
          />
          <div className="gap-2 flex-colo">
            <h2 className="text-sm font-semibold text-yellowlight">
              {user?.name}
            </h2>
            <h2 className="text-sm font-semibold text-yellowlight">
              {user?.town}
            </h2>
            <p className="text-xs text-text">{user?.address}</p>
            <p className="text-xs text-text">{user?.email}</p>
            <p className="text-xs text-text">{user?.phone}</p>
          </div>
          {/* tabs */}
          <div className="flex-colo gap-3 px-2 xl:px-12 w-full">
            {tabs.map((tab, index) => (
              <button
                onClick={() => setActiveTab(tab.id)}
                key={index}
                className={`
                ${
                  activeTab === tab.id
                    ? "bg-text text-yellowdark"
                    : "bg-dry text-yellowlight hover:bg-text hover:text-dry"
                }
                text-xs gap-4 flex items-center w-full p-4 rounded`}
              >
                <tab.icon className="text-lg" /> {tab.name}
              </button>
            ))}
          </div>
        </div>
        {/* tab panel */}
        <div
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-delay="100"
          data-aos-offset="200"
          className="col-span-12 lg:col-span-8 rounded-xl border-[1px] border-border p-6"
        >
          {tabPanel()}
        </div>
      </div>
    </Layout>
  );
}

export default Settings;
